import { render, staticRenderFns } from "./PFSettlementDisbursementReport.vue?vue&type=template&id=99c9c0f6"
import script from "./PFSettlementDisbursementReport.vue?vue&type=script&lang=js"
export * from "./PFSettlementDisbursementReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports